<template>
  <div>
    <!-- 骨架屏 -->
    <skeleton-screen v-show="!dataLoaded"></skeleton-screen>
    <div
      v-if="dataLoaded"
      class="col-md-12 col-sm-12 col-lg-12 col-xl-12 d-flex pl-0 pr-0 ml-0 mt-3 justify-content-between"
    >
      <div class="col-sm-12 col-xl-12 pl-0 pr-0">
        <div class="pl-0 pr-0 position-relative col-md-3 pl-0 pr-0">
          <!-- 触发Dropdown的按钮 -->
          <!-- <button class="d-flex ckqbb zhankai col-sm-12 dydpd pt-2 pb-2 pl-0 pr-0" type="button" id="dropdownMenuButton"
            @click="gjtoggleDropdown()">
            <div class="d-flex align-items-center justify-content-between col-md-12">
              <div class="sjbxzt" style="font-size: calc(6px + 0.4vw);">{{ hdxw ? hdxw : $t('请选择活动行为') }}
              </div>
              <div>
                <img class="ml-2" style="width: calc(7px + 0.4vw);" src="@/img/daohangl/icon_xlcd_xljt@2x (1).png"
                  alt="" />
              </div>
            </div>
          </button> -->
          <!-- Dropdown内容，使用v-show控制显示 -->
          <div
            class="yuanjiao xlcd position-absolute col-sm-12 text-center pt-2"
            aria-labelledby="dropdownMenuButton"
            v-show="gjisDropdownOpen"
            style="border-radius: 7px; background: #fffaf0; z-index: 999999999"
          >
            <div
              v-for="(item, index) in guojialist"
              :key="index"
              class="dropdown-item xuazz yuanjiao mb-2 sjbxzt"
              :style="{ background: guojiaid == item.id ? '#FFD672' : '' }"
              @click="gjxuanz(item.title, item.id)"
              href="#"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
        <div class="baise col-md-12" style="border-radius: 12px 12px 12px 12px">
          <div class="col-md-12 pl-0 pr-0 pb-0 yuanjiao">
            <div
              class="pt-3 pb-3 d-flex justify-content-between align-items-center"
            >
              <img
                v-if="toxiang == ''"
                class="mr-3 sjtxtp"
                style="
                  width: calc(35px + 0.5vw);
                  height: calc(35px + 0.5vw);
                  border-radius: 50%;
                "
                src="@/img/details/pic_grzx_beijingzhuangshitu@2x.png"
                alt=""
              />
              <img
                v-else
                class="mr-3 sjtxtp"
                style="
                  width: calc(35px + 0.5vw);
                  height: calc(35px + 0.5vw);
                  border-radius: 50%;
                "
                :src="toxiang"
                alt=""
              />
              <input
                readonly
                @click="favtiewen()"
                class="form-control srk mr-3 srkjul sjbxzt"
                style="height: calc(40px + 0.4vw); background: #fffdf8"
                type="text"
                :placeholder="$t('你在想什么？')"
                plaintext="true"
                aria-label="Username"
                aria-describedby="basic-addon1"
              />
              <!-- <input v-model="nzxsmn" class="form-control srk mr-3 srkjul sjbxzt" style="height: calc(40px + 0.4vw);background: #FFFDF8" type="text" :placeholder="$t('你在想什么？')" plaintext='true' aria-label="Username" aria-describedby="basic-addon1">
              <div v-if="sctpsp" style="width: calc(120px + 0.4vw);" class="d-flex align-items-center p-3 fbtw curpo tpxfbd sjibanb" @click="favtiewen()">
                <img class="mr-1 widtshh" src="@/img/daohangl/btn_hssy_fbtw@2x.png" alt="" />
                <div class="fbtw-zi">{{ $t("发布帖文") }}</div>
              </div>
              <div v-else style="width: calc(120px + 0.4vw);background-color: #E5E5E5;color: #000;" class="d-flex align-items-center p-3 fbtw sjibanb">
                <img class="mr-1 widtshh" src="@/img/daohangl/btn_hssy_fbtw@2x.png" alt="" />
                <div class="fbtw-zi">{{ $t("发布帖文") }}</div>
              </div>
              <div v-if="sctpsp" style="width: calc(165px + 0.4vw);text-align: center;color: #000;" class=" pl-2 pb-2 pt-1 pr-1 fbtw curpo  aaaaa" @click="favtiewen()">
                <img class="mr-1 mt-1 widtshh sjfjtp" src="@/img/daohangl/btn_hssy_fbtw@2x.png" alt="" />
                <span class="fbtw-zi sjbxzt">{{ $t("发布帖文") }}</span>
              </div>
              <div v-else style="width: calc(165px + 0.4vw);text-align: center;background-color: #E5E5E5;color: #000;" class=" pl-2 pb-2 pt-1 pr-1 fbtw curpo  aaaaa">
                <img class="mr-1 mt-1 widtshh sjfjtp" src="@/img/daohangl/btn_hssy_fbtw@2x.png" alt="" />
                <span class="fbtw-zi sjbxzt">{{ $t("发布帖文") }}</span>
              </div> -->
            </div>
            <!-- <div class="col-sm-12 mb-3" style="height: 1px;background: #E5E5E5;"></div>
            <div class="progress mt-3 mb-3" v-if="uploadProgressshow">
              <div class="progress-bar custom-progress-bar" role="progressbar" :style="{ 'width': uploadProgress }"
                aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
            </div> -->
            <!-- <div class="d-flex align-items-center">
              <div class="curpo d-flex mr-3" @click="fbtpshuz()">
                <input ref="fbtp" type="file" multiple @change="fbtpimage" style="display: none;">
                <img class="mr-2 sjwidtshhs widtshhs" src="@/img/daohangl/icon_hssy_fbtw_tupian@2x.png" alt="" />
                <div class="sjbxzt" style="font-size: calc(5px + 0.4vw);color: #000;">{{ $t("发布图片") }}</div>
              </div>
              <div class="curpo d-flex" @click="fbspshuz()">
                <input ref="fbsp" type="file" @change="fbspinput" style="display: none;">
                <img class="mr-2 sjwidtshhs widtshhs" src="@/img/daohangl/icon_hssy_fbtw_yingpian@2x.png" alt="" />
                <div class="sjbxzt" style="font-size: calc(5px + 0.4vw);color: #000;">{{ $t("发布影片") }}</div>
              </div>
            </div> -->
            <!-- <div class="col-sm-12 pl-0 pr-0 d-flex" style="flex-wrap: wrap;">
              <div class="col-sm-2 mt-3" v-for="(item, index) in fbtplist" :key="index" style="position: relative;">
                <img style="width: 100%;height: calc(70px + 0.5vw);border-radius: 12px;object-fit: cover;"
                  :src="item.src" alt="">
                <img class="curpo" @click="shanctp(index)"
                  style="position: absolute;width: calc(12px + 0.5vw);right: 10%;"
                  src="@/img/grzx/icon_guanbitupian@2x.png" alt="">
              </div>
              <div class="col-sm-2 mt-3" v-for="(item, index) in fbsplist" :key="index" style="position: relative;">
                <video style="width: 100%;height: calc(70px + 0.5vw);border-radius: 12px;" alt="">
                  <source :src="item.src" type="video/mp4">
                  <source :src="item.src" type="video/mov">
                  <source :src="item.src" type="video/avi">
                  <source :src="item.src" type="video/mkv">
                  <source :src="item.src" type="video/flv">
                  <source :src="item.src" type="video/hevc">
                  <source :src="item.src" type="video/3gp">
                </video>
                <img class="curpo" @click="fbsplist = [], fbspathplist = []"
                  style="position: absolute;width: calc(12px + 0.5vw);right: 10%;"
                  src="@/img/grzx/icon_guanbitupian@2x.png" alt="">
              </div>
            </div> -->
          </div>
        </div>
        <!-- 列表 -->
        <!-- 列表 -->
        <div class="col-md-12 pl-0 pr-0 mt-3">
          <div
            v-for="(item, index) in info.moment.data"
            :key="index"
            class="col-md-12 mb-3 pb-3 yuanjiao baise pt-3"
          >
            <div
              class="col-sm-12 pl-0 pr-0 d-flex align-items-center"
              style="justify-content: space-between"
            >
              <div class="d-flex align-items-center">
                <img
                  class="curpo sjtxtp mr-3"
                  @click="hnsbui(item.user_id, item.user_slug)"
                  style="
                    width: calc(35px + 0.5vw);
                    height: calc(35px + 0.5vw);
                    border-radius: 50%;
                  "
                  :src="item.avatar ? item.avatar : ''"
                  alt=""
                />
                <div>
                  <div style="font-size: calc(6px + 0.5vw); font-weight: 500">
                    <span
                      class="curpo sjbzt"
                      @click="hnsbui(item.user_id, item.user_slug)"
                      >{{ item.nickname }}</span
                    >
                    <!-- 判断如果是别的活动啥玩意的显示这玩意 -->
                    <span class="ml-2 curpo sjbzt" @click="fcasa(item)">{{
                      item.activity_id > 0
                        ? $t("在活动") + item.activity_name + $t("中发布了更新")
                        : item.organization_id > 0
                        ? item.organization_identity == 2
                          ? $t("在团体") +
                            item.organization_name +
                            $t("中发布了更新")
                          : $t("在企业") +
                            item.organization_name +
                            $t("中发布了更新")
                        : ""
                    }}</span>
                  </div>
                  <div
                    @click="hnsbui(item.user_id, item.user_slug)"
                    class="curpo sjbxzt"
                    style="font-size: calc(5px + 0.5vw); color: #666666"
                  >
                    {{ timeFilter(item.create_time) }}
                  </div>
                </div>
              </div>
              <div v-if="item.is_owner == 1">
                <div class="mb-2" @click="tpsdin(item.id)">
                  <img class="ddd curpo ckqb" src="@/img/shanc.png" alt="" />
                </div>
                <div
                  v-show="scshow && scdid == item.id"
                  style="
                    border-radius: 7px;
                    background: #fffaf0;
                    max-height: 200px;
                    overflow-y: auto;
                    position: absolute;
                    right: 10px;
                    z-index: 99999;
                  "
                >
                  <a
                    class="dropdown-item sjbxzt yuanjiao mb-2"
                    @click="editBtn(item, index)"
                    href="#"
                  >
                    <img
                      style="width: 20px; height: 20px"
                      src="../../img/deitImgs.png"
                      alt=""
                    />{{ $t("編輯") }}</a
                  >
                  <a
                    class="dropdown-item sjbxzt yuanjiao mb-2"
                    @click="qbudsc(item.id, index)"
                    href="#"
                  >
                    <img
                      style="width: 20px; height: 20px"
                      src="../../img/deleteImg.png"
                      alt=""
                    />
                    {{ $t("删除") }}</a
                  >
                </div>
              </div>
              <!-- <div v-if="item.is_owner == 1">
                <div class="mb-2" @click="tpsdin(item.id)"><img class="ddd curpo ckqb" src="@/img/shanc.png" alt="">
                </div>
                <div @click="qbudsc(item.id, index)" v-if="scshow && scdid == item.id"
                  class="position-absolute d-flex pt-3 pb-3 pl-4 pr-4 align-items-center yinchez yuanjiao curpo ckqbb">
                  <img class="yinchezimg mr-1" src="@/img/zzdsc.png" alt="">
                  <div class="shanc">{{ $t("删除") }}</div>
                </div>
              </div> -->
            </div>
            <div
              class="mt-3 mb-3 sjbzt"
              style="
                line-height: calc(23px + 0.5vw);
                font-size: calc(6px + 0.5vw);
              "
            >
              {{ item.content }}
            </div>
            <!-- 图片 -->
            <div class="gallery">
              <div v-if="item.image.length == 1" style="width: 100%">
                <div
                  class="gallery-item"
                  v-show="item.image.length == 1"
                  v-for="(img, index) in item.image"
                  :key="index"
                >
                  <div :class="index == 1 ? 'image-container' : ''">
                    <img
                      @click="showMedia(index, item.image)"
                      style="
                        width: 100%;
                        height: calc(500px + 0.5vw);
                        object-fit: cover;
                      "
                      v-if="img.type == 'image'"
                      class="curpo tpxfbd yuanjiao pgnjksa"
                      :src="img.src"
                    />
                    <video
                      style="width: 100%; height: calc(500px + 0.5vw)"
                      v-else
                      lass="curpo tpxfbd"
                      controls
                      class="fullscreen-video yuanjiao pgnjksa"
                    >
                      <source :src="img.src" type="video/mp4" />
                      <source :src="img.src" type="video/mov" />
                      <source :src="img.src" type="video/avi" />
                      <source :src="img.src" type="video/mkv" />
                      <source :src="img.src" type="video/flv" />
                      <source :src="img.src" type="video/hevc" />
                      <source :src="img.src" type="video/3gp" />
                    </video>
                  </div>
                </div>
              </div>
              <div
                v-if="item.image.length == 2"
                style="
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <div
                  style="width: 49.3%"
                  class="sjbkd"
                  v-for="(img, index) in item.image"
                  :key="index"
                >
                  <div :class="index == 1 ? 'image-container' : ''">
                    <img
                      @click="showMedia(index, item.image)"
                      style="
                        width: 100%;
                        height: calc(400px + 0.5vw);
                        object-fit: cover;
                      "
                      v-if="img.type == 'image'"
                      class="curpo tpxfbd yuanjiao sfdvx"
                      :src="img.src"
                    />
                    <video
                      style="width: 100%; height: calc(400px + 0.5vw)"
                      v-else
                      lass="curpo tpxfbd"
                      controls
                      class="fullscreen-video yuanjiao sfdvx"
                    >
                      <source :src="img.src" type="video/mp4" />
                      <source :src="img.src" type="video/mov" />
                      <source :src="img.src" type="video/avi" />
                      <source :src="img.src" type="video/mkv" />
                      <source :src="img.src" type="video/flv" />
                      <source :src="img.src" type="video/hevc" />
                      <source :src="img.src" type="video/3gp" />
                    </video>
                  </div>
                </div>
              </div>
              <div v-if="item.image.length == 3" style="width: 100%">
                <div
                  class="gallery-item mb-3 sjmb"
                  v-show="index == 0"
                  v-for="(img, index) in item.image"
                  :key="index"
                >
                  <div :class="index == 1 ? 'image-container' : ''">
                    <img
                      @click="showMedia(index, item.image)"
                      style="
                        width: 100%;
                        height: calc(400px + 0.5vw);
                        object-fit: cover;
                      "
                      v-if="img.type == 'image'"
                      class="curpo tpxfbd yuanjiao sfdvx"
                      :src="img.src"
                    />
                    <video
                      style="width: 100%; height: calc(400px + 0.5vw)"
                      v-else
                      lass="curpo tpxfbd"
                      controls
                      class="fullscreen-video yuanjiao sfdvx"
                    >
                      <source :src="img.src" type="video/mp4" />
                      <source :src="img.src" type="video/mov" />
                      <source :src="img.src" type="video/avi" />
                      <source :src="img.src" type="video/mkv" />
                      <source :src="img.src" type="video/flv" />
                      <source :src="img.src" type="video/hevc" />
                      <source :src="img.src" type="video/3gp" />
                    </video>
                  </div>
                </div>
                <div
                  style="
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  <div
                    style="width: 49.3%"
                    class="sjbkd"
                    v-show="index != 0"
                    v-for="(img, index) in item.image"
                    :key="index"
                  >
                    <div :class="index == 1 ? 'image-container' : ''">
                      <img
                        @click="showMedia(index, item.image)"
                        style="
                          width: 100%;
                          height: calc(250px + 0.5vw);
                          object-fit: cover;
                        "
                        v-if="img.type == 'image'"
                        class="curpo tpxfbd yuanjiao sjitp"
                        :src="img.src"
                      />
                      <video
                        style="width: 100%; height: calc(250px + 0.5vw)"
                        v-else
                        lass="curpo tpxfbd"
                        controls
                        class="fullscreen-video yuanjiao sjitp"
                      >
                        <source :src="img.src" type="video/mp4" />
                        <source :src="img.src" type="video/mov" />
                        <source :src="img.src" type="video/avi" />
                        <source :src="img.src" type="video/mkv" />
                        <source :src="img.src" type="video/flv" />
                        <source :src="img.src" type="video/hevc" />
                        <source :src="img.src" type="video/3gp" />
                      </video>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="item.image.length == 4" style="width: 100%">
                <div
                  class="mb-3 sjmb"
                  style="
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  <div
                    style="width: 49.3%"
                    class="sjbkd"
                    v-show="index < 2"
                    v-for="(img, index) in item.image"
                    :key="index"
                  >
                    <div :class="index == 1 ? 'image-container' : ''">
                      <img
                        @click="showMedia(index, item.image)"
                        style="
                          width: 100%;
                          height: calc(350px + 0.5vw);
                          object-fit: cover;
                        "
                        v-if="img.type == 'image'"
                        class="curpo tpxfbd yuanjiao sjitp"
                        :src="img.src"
                      />
                      <video
                        style="width: 100%; height: calc(350px + 0.5vw)"
                        v-else
                        lass="curpo tpxfbd"
                        controls
                        class="fullscreen-video yuanjiao sjitp"
                      >
                        <source :src="img.src" type="video/mp4" />
                        <source :src="img.src" type="video/mov" />
                        <source :src="img.src" type="video/avi" />
                        <source :src="img.src" type="video/mkv" />
                        <source :src="img.src" type="video/flv" />
                        <source :src="img.src" type="video/hevc" />
                        <source :src="img.src" type="video/3gp" />
                      </video>
                    </div>
                  </div>
                </div>
                <div
                  style="
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  <div
                    style="width: 49.3%"
                    class="sjbkd"
                    v-show="index >= 2"
                    v-for="(img, index) in item.image"
                    :key="index"
                  >
                    <div :class="index == 1 ? 'image-container' : ''">
                      <img
                        @click="showMedia(index, item.image)"
                        style="
                          width: 100%;
                          height: calc(350px + 0.5vw);
                          object-fit: cover;
                        "
                        v-if="img.type == 'image'"
                        class="curpo tpxfbd yuanjiao sjitp"
                        :src="img.src"
                      />
                      <video
                        style="width: 100%; height: calc(350px + 0.5vw)"
                        v-else
                        lass="curpo tpxfbd"
                        controls
                        class="fullscreen-video yuanjiao sjitp"
                      >
                        <source :src="img.src" type="video/mp4" />
                        <source :src="img.src" type="video/mov" />
                        <source :src="img.src" type="video/avi" />
                        <source :src="img.src" type="video/mkv" />
                        <source :src="img.src" type="video/flv" />
                        <source :src="img.src" type="video/hevc" />
                        <source :src="img.src" type="video/3gp" />
                      </video>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="item.image.length >= 5"
                style="
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <div style="width: 49.3%" class="sjbkd">
                  <div
                    style="width: 100%"
                    class="mb-3 sjmb"
                    v-show="index <= 1"
                    v-for="(img, index) in item.image"
                    :key="index"
                  >
                    <div
                      style="width: 100%"
                      :class="index == 4 ? 'image-container' : ''"
                    >
                      <img
                        @click="showMedia(index, item.image)"
                        style="
                          width: 100%;
                          height: calc(400px + 0.5vw);
                          object-fit: cover;
                        "
                        v-if="img.type == 'image'"
                        class="curpo tpxfbd yuanjiao sjitp"
                        :src="img.src"
                      />
                      <video
                        style="width: 100%; height: calc(400px + 0.5vw)"
                        v-else
                        lass="curpo tpxfbd"
                        controls
                        class="fullscreen-video yuanjiao sjitp"
                      >
                        <source :src="img.src" type="video/mp4" />
                        <source :src="img.src" type="video/mov" />
                        <source :src="img.src" type="video/avi" />
                        <source :src="img.src" type="video/mkv" />
                        <source :src="img.src" type="video/flv" />
                        <source :src="img.src" type="video/hevc" />
                        <source :src="img.src" type="video/3gp" />
                      </video>
                    </div>
                  </div>
                </div>
                <div style="width: 49.3%" class="sjbkd">
                  <div
                    style="width: 100%"
                    class="mb-3 sjmb"
                    v-show="index > 1 && index <= 4"
                    v-for="(img, index) in item.image"
                    :key="index"
                  >
                    <div
                      style="width: 100%"
                      :class="index == 4 ? 'image-container' : ''"
                    >
                      <img
                        @click="showMedia(index, item.image)"
                        style="
                          width: 100%;
                          height: calc(257px + 0.5vw);
                          object-fit: cover;
                        "
                        v-if="img.type == 'image'"
                        class="curpo tpxfbd yuanjiao sjtpr"
                        :src="img.src"
                      />
                      <video
                        style="width: 100%; height: calc(257px + 0.5vw)"
                        v-else
                        lass="curpo tpxfbd"
                        controls
                        class="fullscreen-video yuanjiao sjtpr"
                      >
                        <source :src="img.src" type="video/mp4" />
                        <source :src="img.src" type="video/mov" />
                        <source :src="img.src" type="video/avi" />
                        <source :src="img.src" type="video/mkv" />
                        <source :src="img.src" type="video/flv" />
                        <source :src="img.src" type="video/hevc" />
                        <source :src="img.src" type="video/3gp" />
                      </video>
                      <div
                        @click="showMedia(index, item.image)"
                        v-if="item.image.length > 5 && index == 4"
                        class="overlay curpo yuanjiao tpxfbd"
                        style="
                          width: 100%;
                          color: white;
                          display: flex;
                          align-items: center;
                          justify-content: space-around;
                        "
                        :class="index == 4 ? 'last-image' : ''"
                      >
                        <div style="font-size: calc(7px + 0.5vw)">
                          + {{ item.image.length - 5 }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isFullscreen" class="fullscreen-modal">
              <template v-if="currentMediaType === 'image'">
                <img
                  :src="mediaList[currentIndex].src"
                  alt="fullscreen"
                  class="fullscreen-image"
                />
              </template>
              <template v-else-if="currentMediaType === 'video'">
                <video controls class="fullscreen-video">
                  <source :src="mediaList[currentIndex].src" type="video/mp4" />
                  <source :src="mediaList[currentIndex].src" type="video/mov" />
                  <source :src="mediaList[currentIndex].src" type="video/avi" />
                  <source :src="mediaList[currentIndex].src" type="video/mkv" />
                  <source :src="mediaList[currentIndex].src" type="video/flv" />
                  <source
                    :src="mediaList[currentIndex].src"
                    type="video/hevc"
                  />
                  <source :src="mediaList[currentIndex].src" type="video/3gp" />
                </video>
              </template>
              <img
                class="curpo"
                @click="prevMedia(currentIndex)"
                style="
                  width: calc(30px + 0.5vw);
                  height: calc(30px + 0.5vw);
                  position: absolute;
                  left: 5%;
                  top: 50%;
                "
                src="@/img/daohangl/cb19415c55cd84d9d1ec84d64975476.png"
              />
              <img
                class="curpo"
                @click="nextMedia"
                style="
                  width: calc(30px + 0.5vw);
                  height: calc(30px + 0.5vw);
                  position: absolute;
                  right: 5%;
                  top: 50%;
                "
                src="@/img/daohangl/450d77812abbc1eeb69e7b12b85d1b2.png"
              />
              <img
                class="curpo"
                @click="closeFullscreen"
                style="
                  width: calc(30px + 0.5vw);
                  height: calc(30px + 0.5vw);
                  position: absolute;
                  right: 5%;
                  top: 5%;
                "
                src="@/img/details/cha.png"
              />
            </div>
            <div
              v-if="item.activity_name"
              style="
                display: flex;
                align-items: center;
                color: #666666;
                font-size: calc(6px + 0.4vw);
                margin-top: 10px;
              "
            >
              <img
                style="width: 10px; height: 10px"
                src="../../img/activiteImgoff.png"
                alt=""
              />
              <div style="margin-left: 5px">
                {{ item.activity_name }} {{ item.action_title }}
              </div>
            </div>
            <div
              v-if="item.address"
              style="
                display: flex;
                align-items: center;
                color: #666666;
                font-size: calc(6px + 0.4vw);
                margin-top: 10px;
              "
            >
              <!-- 位置 -->
              <img
                style="width: 10px; height: 10px"
                src="../../img/dkdw.png"
                alt=""
              />
              <div style="margin-left: 5px">{{ item.address }}</div>
            </div>
            <div
              class="d-flex justify-content-between align-items-center mt-2 ml-2"
            >
              <div v-if="item.like" style="width: 60%">
                <img
                  v-for="(sss, mmm) in item.like"
                  :key="mmm"
                  class="mr-2"
                  style="width: calc(20px + 0.5vw); margin-left: -10px"
                  :src="sss.like_type.image"
                  alt=""
                />
                <span
                  v-if="item.like.length > 0"
                  class="sjbxzt"
                  style="font-size: calc(6px + 0.4vw); color: #666666"
                >
                  <span v-for="(sss, mmm) in item.like" :key="mmm"
                    >{{ sss.user_nickname }}{{ $t("和") }}</span
                  >
                  {{ $t("其他") }} {{ item.like_num ? item.like_num - 1 : 0 }}
                  {{ $t("人做出反应") }}</span
                >
                <span
                  v-else
                  class="ml-2 sjbxzt"
                  style="font-size: calc(6px + 0.4vw); color: #666666"
                  >{{ $t("还未有人做出反应") }}</span
                >
              </div>
              <!-- 展开收回 -->
              <div
                v-if="item.isExpanded && gyiasdid == item.id"
                @click="expandfun(index, item.id, '', 0)"
                class="zhankai zjpadding d-flex pt-2 pb-2 pl-3 pr-3 align-items-center curpo tpxfbd"
              >
                <div class="mr-2 sjbxzt" style="font-size: calc(5px + 0.5vw)">
                  {{ $t("留言收回") }}
                </div>
                <img
                  class="xiaojiant"
                  style="width: calc(7px + 0.4vw); height: calc(7px + 0.4vw)"
                  src="@/img/daohangl/icon_hssy_zk@2x.png"
                  alt=""
                />
              </div>
              <div
                v-else
                @click="
                  expandfun(index, item.id, '', 1),
                    (pldsjuijjm = $t('发表评论')),
                    (plyjid = ''),
                    (gyiasdid = item.id),
                    (qientids = ''),
                    (gyiasdid = item.id)
                "
                class="zhankai zjpadding d-flex pt-2 pb-2 pl-3 pr-3 align-items-center curpo tpxfbd"
              >
                <div class="mr-2 sjbxzt" style="font-size: calc(5px + 0.5vw)">
                  {{ $t("留言展开") }}
                </div>
                <img
                  class="xiaojiant"
                  style="width: calc(7px + 0.4vw); height: calc(7px + 0.4vw)"
                  src="@/img/daohangl/icon_hssy_zk@2x.png"
                  alt=""
                />
              </div>
            </div>
            <div
              class="mt-3 mb-2"
              style="height: 1px; width: 100%; background: #e5e5e5"
            ></div>
            <!-- 爱心留言分享 -->
            <div class="d-flex align-items-center">
              <!-- 赞图片 -->
              <button
                v-if="!item.like_type"
                ref="activeElement"
                @click.stop="handleClickOnElement"
                @click="(hover = true), (gyiasdid = item.id)"
                style="border: none; background: none; position: relative"
              >
                <div class="d-flex mr-3 curpo ckqb align-items-center">
                  <img
                    class="mr-1 zlxtop"
                    style="width: calc(15px + 0.5vw)"
                    src="@/img/icon_weidianzan@2x.png"
                    alt=""
                  />
                  <div
                    class="sjbxzt"
                    style="font-size: calc(6px + 0.4vw); color: #666666"
                  >
                    {{ $t("赞") }}
                  </div>
                </div>
                <button
                  @mouseleave="hover = false"
                  v-if="hover && item.id == gyiasdid"
                  class="d-flex align-items-center mr-3 pt-1 pb-1 pl-3 pr-3 pt-3 pb-3 position-absolute"
                  style="
                    background: #fffaf0;
                    border-radius: 12px;
                    border: none;
                    bottom: -75px;
                    z-index: 999;
                  "
                >
                  <div v-for="(ism, inde) in xthhh" :key="inde">
                    <img
                      class="mr-2 jiantofangda curpo"
                      @click="dianzhan(item.id, ism.id, ism)"
                      style="
                        width: calc(27px + 0.4vw);
                        height: calc(27px + 0.4vw);
                      "
                      :src="ism.image"
                      alt=""
                    />
                  </div>
                </button>
              </button>
              <div
                v-else
                class="d-flex mr-3 curpo ckqb align-items-center"
                @click="dianzhan(item.id)"
              >
                <img
                  class="mr-1 zlxtops"
                  style="width: calc(15px + 0.5vw)"
                  :src="item.like_type.image"
                  alt=""
                />
                <div
                  class="sjbxzt"
                  style="font-size: calc(6px + 0.4vw); color: #666666"
                >
                  {{ item.like_type.name }}
                </div>
              </div>

              <div
                class="d-flex mr-3 curpo ckqb align-items-center"
                @click="
                  (pldsjuijjm = $t('发表评论')),
                    (plyjid = ''),
                    (gyiasdid = item.id),
                    (qientids = '')
                "
              >
                <img
                  class="mr-1 zlxtop"
                  style="width: calc(15px + 0.5vw)"
                  src="@/img/daohangl/icon_hssy_twly@2x.png"
                  alt=""
                />
                <div
                  class="sjbxzt"
                  style="font-size: calc(6px + 0.4vw); color: #666666"
                >
                  {{ $t("留言") }}
                </div>
              </div>
              <div class="d-flex curpo ckqb align-items-center mr-3">
                <img
                  class="mr-1 zlxtop"
                  style="width: calc(15px + 0.5vw)"
                  src="@/img/daohangl/icon_hssy_twfx@2x.png"
                  alt=""
                />
                <div
                  class="sjbxzt"
                  style="font-size: calc(6px + 0.4vw); color: #666666"
                >
                  {{ $t("分享") }}
                </div>
              </div>
              <!-- <div class="d-flex curpo ckqbb align-items-center">
                <div v-if="item.is_owner == 1" @click="qbudsc(item.id, index)" style="font-size: calc(6px + 0.4vw);color: #666666;">
                  {{ $t("删除") }}
                </div>
              </div> -->
            </div>
            <!-- 列表聊天那块 -->
            <div
              class="pt-2 mt-2 ltdgdt"
              v-if="item.isExpanded && item.id == gyiasdid"
            >
              <div
                class="mb-3"
                v-for="(lunt, inexlu) in item.pllist"
                :key="inexlu"
              >
                <div
                  class="d-flex align-items-center"
                  style="justify-content: space-between"
                >
                  <div class="d-flex align-items-center">
                    <img
                      class="mr-2"
                      style="
                        width: calc(30px + 0.6vw);
                        height: calc(30px + 0.6vw);
                        border-radius: 50%;
                      "
                      :src="lunt.avatar ? lunt.avatar : ''"
                      alt=""
                    />
                    <div
                      class="mr-2 sjbzt"
                      style="font-size: calc(7px + 0.5vw); font-weight: 500"
                    >
                      {{ lunt.nickname }}
                    </div>
                    <div
                      class="mt-1 sjbxzt"
                      style="font-size: calc(5px + 0.4vw)"
                    >
                      {{ timeFilter(lunt.create_time) }}
                    </div>
                  </div>
                  <div
                    v-if="lunt.is_owner == 1"
                    style="position: relative"
                    class="mr-3"
                  >
                    <div class="mb-2" @click="tpsdinyiji(lunt.id)">
                      <img
                        class="ddd curpo ckqb"
                        src="@/img/shanc.png"
                        alt=""
                      />
                    </div>
                    <div
                      @click="scpljibdz(item.id, lunt.id, index)"
                      v-if="scshowyiji && scdidyiji == lunt.id"
                      class="position-absolute d-flex pt-3 pb-3 pl-4 pr-4 align-items-center yinchez yuanjiao curpo ckqbb"
                    >
                      <img
                        class="yinchezimg mr-1"
                        src="@/img/zzdsc.png"
                        alt=""
                      />
                      <div class="shanc sjbxzt">{{ $t("删除") }}</div>
                    </div>
                  </div>
                </div>
                <div class="mt-2" style="margin-left: calc(22px + 0.6vw)">
                  <div
                    class="p-3 yuanjiao mr-3 sjbxzt"
                    style="
                      background: #f6f4f0;
                      width: auto;
                      font-size: calc(7px + 0.4vw);
                      font-weight: 500;
                    "
                  >
                    {{ lunt.content }}
                  </div>
                  <div
                    class="d-flex mt-3 align-items-center"
                    style="color: #666666"
                  >
                    <div
                      @click="pljibdz(item.id, lunt.id, index)"
                      class="mr-3 srkjul curpo d-flex ckqb align-items-center sjbxzt"
                      style="font-size: calc(6px + 0.4vw)"
                    >
                      <img
                        v-if="lunt.is_like == 0"
                        class="zlxtop mr-1"
                        style="width: calc(10px + 0.5vw)"
                        src="@/img/daohangl/icon_hssy_tepl_wdz@2x.png"
                        alt=""
                      />
                      <img
                        v-else
                        style="width: calc(10px + 0.5vw)"
                        class="zlxtop mr-1"
                        src="@/img/daohangl/icon_hssy_dz@2x.png"
                        alt=""
                      />
                      <div>{{ $t("喜欢") }}</div>
                    </div>
                    <div
                      @click="
                        (pldsjuijjm =
                          $t('回复') + lunt.nickname + $t('的评论')),
                          (plyjid = lunt.id),
                          (qientids = '')
                      "
                      class="mr-3 curpo ckqb sjbxzt"
                      style="font-size: calc(6px + 0.4vw); color: #fab1ab"
                    >
                      {{ $t("回复") }}
                    </div>
                  </div>
                </div>
                <div
                  class="mt-3"
                  v-for="(qient, iasd) in lunt.children"
                  :key="iasd"
                  style="margin-left: calc(22px + 0.6vw)"
                >
                  <div
                    class="d-flex align-items-center"
                    style="justify-content: space-between"
                  >
                    <div class="d-flex align-items-center">
                      <img
                        class="mr-2"
                        style="
                          width: calc(30px + 0.6vw);
                          height: calc(30px + 0.6vw);
                          border-radius: 50%;
                        "
                        :src="qient.avatar ? qient.avatar : ''"
                        alt=""
                      />
                      <div
                        class="mr-2 sjbzt"
                        style="font-size: calc(7px + 0.5vw); font-weight: 500"
                      >
                        {{ qient.nickname }}
                      </div>
                      <div
                        class="sjbxzt mt-1"
                        style="font-size: calc(5px + 0.4vw)"
                      >
                        {{ timeFilter(qient.create_time) }}
                      </div>
                    </div>
                    <div
                      v-if="qient.is_owner == 1"
                      style="position: relative"
                      class="mr-3"
                    >
                      <div class="mb-2" @click="tpsdinerji(qient.id)">
                        <img
                          class="ddd curpo ckqb"
                          src="@/img/shanc.png"
                          alt=""
                        />
                      </div>
                      <div
                        @click="scpljibdz(item.id, qient.id, index)"
                        v-if="scshowerji && scdiderji == qient.id"
                        class="position-absolute d-flex pt-3 pb-3 pl-4 pr-4 align-items-center yinchez yuanjiao curpo ckqbb"
                      >
                        <img
                          class="yinchezimg mr-1"
                          src="@/img/zzdsc.png"
                          alt=""
                        />
                        <div class="shanc">{{ $t("删除") }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="mt-3" style="margin-left: calc(22px + 0.6vw)">
                    <div
                      class="p-3 yuanjiao mr-3 sjbxzt"
                      style="
                        background: #f6f4f0;
                        width: auto;
                        font-size: calc(7px + 0.4vw);
                        font-weight: 500;
                      "
                    >
                      {{ qient.content }}
                    </div>
                    <div
                      class="d-flex mt-4 align-items-center"
                      style="color: #666666"
                    >
                      <div
                        @click="pljibdz(item.id, qient.id, index)"
                        class="mr-3 curpo sjbxzt d-flex ckqb align-items-center"
                        style="font-size: calc(6px + 0.4vw)"
                      >
                        <img
                          v-if="qient.is_like == 0"
                          class="zlxtop mr-1"
                          style="width: calc(10px + 0.5vw)"
                          src="@/img/daohangl/icon_hssy_tepl_wdz@2x.png"
                          alt=""
                        />
                        <img
                          v-else
                          class="zlxtop mr-1"
                          style="width: calc(10px + 0.5vw)"
                          src="@/img/daohangl/icon_hssy_dz@2x.png"
                          alt=""
                        />
                        <div>{{ $t("喜欢") }}</div>
                      </div>
                      <div
                        @click="
                          (pldsjuijjm =
                            $t('回复') + qient.nickname + $t('的评论')),
                            (qientids = qient.user_id),
                            (plyjid = lunt.id)
                        "
                        class="mr-3 curpo sjbxzt ckqb"
                        style="font-size: calc(6px + 0.4vw); color: #fab1ab"
                      >
                        {{ $t("回复") }}
                      </div>
                      <!-- <div @click="scpljibdz(item.id, qient.id, index)" v-if="qient.is_owner == 1" class="mr-3 curpo ckqbb" style="font-size: calc(6px + 0.4vw);">{{
													$t("删除") }}
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 发表评论 -->
            <div
              v-if="item.id == gyiasdid"
              class="d-flex align-items-center yuanjiao mt-3 mb-1"
              style="position: relative"
            >
              <img
                class="dingwd zlxtops position-absolute"
                style="left: 10px; z-index: 9"
                src="@/img/daohangl/pic_hssy_twtx@2x.png"
                alt=""
              />
              <input
                v-model="liebfbpl"
                class="form-control col-md-12 pl-5 pr-5 sjbzt"
                :placeholder="pldsjuijjm"
                style="
                  background: #f6f4f0;
                  border: none;
                  border-radius: 13px;
                  font-size: calc(6px + 0.4vw);
                  padding-top: 22px;
                  padding-bottom: 22px;
                "
                type="text"
                plaintext="true"
                aria-label="Username"
                aria-describedby="basic-addon1"
              />
              <img
                @click="expandfun(index, item.id, 'v')"
                class="dingwd zlxtops position-absolute curpo jiantofangda"
                style="right: 10px; z-index: 9"
                src="@/img/daohangl/icon_hssy_twfb@2x.png"
                alt=""
              />
            </div>
          </div>
          <div class="d-flex justify-content-center" style="margin: auto">
            <div
              v-if="info.moment.data.length == 0"
              style="margin-bottom: 10vh"
            >
              <empty></empty>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      title="請選擇表情"
      v-model="emojiType"
      style="text-align: center"
      modal-class="custom-modal-width"
      :hide-footer="true"
      ok-only
      ok-disabled
      :hide-backdrop="true"
      :no-close-on-backdrop="isLoading"
      size="md"
      @hide="emojiType = false"
    >
      <div style="display: flex; align-items: center; text-align: center">
        <emoji
          v-show="emojiType"
          style="width: 100%; height: 100%; margin-top: 10px"
          @changeEmoji="changeEmoji"
        ></emoji>
      </div>
    </b-modal>
    <b-modal
      v-model="modalShow"
      modal-class="custom-modal-width"
      :no-close-on-backdrop="isLoading"
      size="lg"
      @hide="closeChnage"
      :no-close-on-esc="isLoading"
      :centered="true"
      hide-header
      hide-footer
    >
      <div
        style="width: 100%; text-align: center; height: auto"
        class="pb-2 position-relative"
      >
        <div v-show="clockBool || activityBool" style="position: absolute">
          <img
            @click="fanhui"
            class="mt-1 mb-2 curpo dcbd sjdsad"
            style="width: calc(25px + 0.4vw)"
            src="@/img/login/icon_fanhui@2x.png"
            alt=""
          />
        </div>
        <img
          @click="modalShow = false"
          class="position-absolute curpo sbxfbd"
          style="width: calc(15px + 0.5vw); right: 10px"
          src="@/img/details/cha.png"
          alt=""
        />
        <div style="font-size: calc(9px + 0.4vw); font-weight: 700">
          {{ $t("發文") }}
        </div>
        <!-- 内容填写 -->
        <div v-show="!clockBool && !activityBool">
          <!-- 头像信息 -->
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 37px;
            "
          >
            <div class="heardCss">
              <!-- <img class="mr-3 sjtxtp" style="width: calc(35px + 0.5vw);height: calc(35px + 0.5vw);border-radius: 50%;"
                :src="info.avatar" alt="" />
              <div>{{ info.username }}</div> -->
              <div></div>
            </div>
            <div>
              <img
                style="cursor: pointer"
                @click="emojiType = !emojiType"
                src="../../img/smileImg.png"
                alt=""
              />
            </div>
          </div>
          <!-- 内容填写 -->
          <div>
            <b-form-textarea
              id="textarea"
              class="contentCss"
              v-model="nzxsmn"
              :placeholder="$t('你在想什麼？')"
              :rows="6"
              :no-resize="true"
              sticky
            ></b-form-textarea>
          </div>
          <!-- 图片视频回显 -->
          <div style="display: flex; flex-wrap: wrap; flex-direction: row">
            <div style="flex-wrap: wrap; display: flex">
              <div
                v-for="(item, index) in fbtplist"
                :key="index"
                style="position: relative; padding: 20px"
              >
                <img
                  style="
                    width: 160px;
                    height: 90px;
                    border-radius: 12px;
                    object-fit: cover;
                  "
                  :src="item.src"
                  alt=""
                />
                <img
                  class="curpo"
                  @click="shanctp(index)"
                  style="
                    position: absolute;
                    width: calc(12px + 0.5vw);
                    right: 10%;
                  "
                  src="@/img/grzx/icon_guanbitupian@2x.png"
                  alt=""
                />
              </div>
              <div
                v-for="(item, index) in fbsplist"
                :key="index"
                style="position: relative; padding: 20px"
              >
                <video
                  style="width: 160px; height: 90px; border-radius: 12px"
                  alt=""
                >
                  <source :src="item.src" type="video/mp4" />
                  <source :src="item.src" type="video/mov" />
                  <source :src="item.src" type="video/avi" />
                  <source :src="item.src" type="video/mkv" />
                  <source :src="item.src" type="video/flv" />
                  <source :src="item.src" type="video/hevc" />
                  <source :src="item.src" type="video/3gp" />
                </video>
                <img
                  class="curpo"
                  @click="(fbsplist = []), (fbspathplist = [])"
                  style="
                    position: absolute;
                    width: calc(12px + 0.5vw);
                    right: 10%;
                  "
                  src="@/img/grzx/icon_guanbitupian@2x.png"
                  alt=""
                />
              </div>
            </div>
            <!-- <div v-for="item in 4">
            <div class="imageCss">
              <img class="curpo"  style="width: 160px;height: 90px;padding: 12px;"
                src="../../img/smileImg.png" alt="" />
                <img class="deleteIMGcss"  style="width: 16px;height: 16px;"
                src="../../img/deleteImgS.png" alt="" />
            </div>
        
          </div> -->
          </div>
          <!-- 定位信息 -->
          <div>
            <div
              v-if="activiteName || behaviorName"
              style="display: flex; align-items: center; margin-top: 12px"
            >
              <img
                src="../../img/activiteImgoff.png"
                style="margin-right: 8px"
                alt=""
              />
              <div>{{ $t(activiteName) }} {{ $t(behaviorName) }}</div>
              <img
                src="../../img/deleteImgF.png"
                v-if="isOne == 1"
                @click="closeAcitvite"
                style="
                  margin-left: 8px;
                  width: 16px;
                  height: 16px;
                  cursor: pointer;
                "
                alt=""
              />
            </div>
            <div
              v-if="searchValue"
              style="display: flex; align-items: center; margin-top: 12px"
            >
              <img src="../../img/dkdw.png" style="margin-right: 8px" alt="" />
              <div>{{ searchValue }}</div>
              <img
                src="../../img/deleteImgF.png"
                @click="searchValue = ''"
                style="
                  margin-left: 8px;
                  width: 16px;
                  height: 16px;
                  cursor: pointer;
                "
                alt=""
              />
            </div>
          </div>
          <div class="progress mt-3 mb-3" v-if="uploadProgressshow">
            <div
              class="progress-bar custom-progress-bar"
              role="progressbar"
              :style="{ width: uploadProgress }"
              aria-valuenow="50"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
          <div class="brCss"></div>
          <!-- 功能 -->
          <div
            style="
              display: flex;
              align-items: center;
              margin-top: 18px;
              justify-content: space-evenly;
            "
          >
            <div class="featureCss" @click="fbtpshuz()">
              <input
                ref="fbtp"
                type="file"
                multiple
                @change="fbtpimage"
                style="display: none"
              />
              <img
                src="../../img/publishImg.png"
                alt=""
                style="width: 24px; height: 24px"
              />
              <div class="textfeatureCss">{{ $t("发布图片") }}</div>
            </div>
            <div class="featureCss" @click="fbspshuz()">
              <input
                ref="fbsp"
                type="file"
                @change="fbspinput"
                style="display: none"
              />
              <img
                src="../../img/publishVideo.png"
                style="width: 24px; height: 24px"
                alt=""
              />
              <div class="textfeatureCss">{{ $t("发布影片") }}</div>
            </div>
            <div class="featureCss" @click="clockBtn">
              <img
                src="../../img/clockimg.png"
                style="width: 24px; height: 24px"
                alt=""
              />
              <div class="textfeatureCss">{{ $t("打卡") }}</div>
            </div>
            <div v-if="isOne == 1" class="featureCss" @click="activityBtn">
              <img
                src="../../img/activiteImg.png"
                style="width: 24px; height: 24px"
                alt=""
              />
              <div class="textfeatureCss">{{ $t("活動") }}</div>
            </div>
          </div>
          <div>
            <button
              :disabled="isLoading"
              @click="qrbulletframe()"
              class="btnCss"
              style="
                font-family: Source Han Sans;
                font-size: 14px;
                font-weight: normal;
                color: #1a1a1a;
                background: #ffd672;
                border: none;
              "
            >
              {{ isOne == 1 ? $t("發文") : $t("編輯") }}
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm ml-2"
                role="status"
                aria-hidden="true"
              >
              </span>
            </button>
          </div>
        </div>
        <!-- 打卡 -->
        <div v-if="clockBool" style="width: 100%; margin-top: 37px">
          <div style="width: 100%; height: 100%">
            <mapLocation
              :mapType="'selectPoint'"
              @updateMapvalue="editmapValue($event)"
              :zoom="15"
              :googleMapCenter="Maporientation"
              :searchValue="searchValue"
            >
            </mapLocation>
          </div>
        </div>
        <!-- 活动 -->
        <div v-if="activityBool" style="width: 100%; margin-top: 37px">
          <div>
            <b-input-group>
              <template v-slot:append>
                <b-input-group-text @click="scarchBtn">
                  <img src="../../img/searchImg.png" alt="" srcset="" />
                </b-input-group-text>
              </template>
              <b-form-input
                style="border-radius: 10px 0 0 10px"
                v-model="activitySearch"
                :placeholder="$t('搜尋')"
              ></b-form-input>
            </b-input-group>
          </div>
          <div style="margin-top: 25px">
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <div class="myactiviteCss">{{ $t("我的活動") }}</div>
              <div class="myactiviteTipCss">
                {{ $t("可選，選擇後將與貼文關聯") }}
              </div>
            </div>
            <div
              v-for="item in moment_activity"
              :key="item.id"
              style="
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                padding: 9px 0;
                cursor: pointer;
              "
              @click.stop="activiteChange(item)"
            >
              <div class="activiteItemcss">
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <img
                    src="../../img/activiteImgoff.png"
                    style="margin-right: 8px"
                    alt=""
                  />
                  <div
                    style="
                      margin: 19px;
                      display: flex;
                      flex-direction: column;
                      align-items: flex-start;
                    "
                  >
                    <div class="acitviteNameCss">{{ $t(item.name) }}</div>
                    <div class="acitviteDataCss">
                      {{ $t(item.activity_time) }}
                    </div>
                  </div>
                </div>
                <div
                  style="position: relative; display: flex; align-items: center"
                  @click.stop="unfoldChange(item)"
                >
                  <div>{{ item.unfold ? "關閉" : "展開" }}</div>
                  <div :class="item.unfold ? 'triangleT' : 'triangleB'"></div>
                </div>
              </div>
              <div v-if="item.unfold" style="width: 100%">
                <div
                  v-for="item2 in item.action"
                  :key="item2.id"
                  style="
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    padding: 9px 0;
                    cursor: pointer;
                  "
                  @click.stop="activiteChange(item, item2)"
                >
                  <div class="activiteItemcss2">
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <div
                        style="
                          margin: 19px;
                          display: flex;
                          flex-direction: column;
                          align-items: flex-start;
                        "
                      >
                        <div class="acitviteNameCss">{{ $t(item2.title) }}</div>
                        <div class="acitviteDataCss2">
                          {{ $t(item2.content) }}
                        </div>
                      </div>
                    </div>
                    <!-- v-if="screenWidth > 990" -->
                    <div class="pointsCss">
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: flex-end;
                        "
                      >
                        <div style="margin-right: 6px">
                          <img
                            src="../../img/pointsgood.png"
                            alt=""
                            srcset=""
                          />
                        </div>
                        <div style="margin-right: 6px">
                          {{ item2.good_coin }}
                        </div>
                        <div>{{ $t("好人積分") }}</div>
                      </div>
                      <div class="Ccss" style="">
                        <div style="margin-right: 6px">
                          <img src="../../img/pointsC.png" alt="" srcset="" />
                        </div>
                        <div style="margin-right: 6px">
                          {{ item2.carbon_coin }}
                        </div>
                        <div>{{ $t("碳積分") }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { EventBus } from "@/views/event-bus.js";
import SkeletonScreen from "../haosttd/SkeletonScreen/guanywmSkeletonScreen.vue";
import {
  common_base,
  image,
  moment_list,
  articleUpdate,
} from "@/request/api.js";
import empty from "@/components/empty/empty.vue";
import mapLocation from "@/components/mapLocation/index";
import emoji from "@/components/emoji/index";
import {
  update_avatar,
  update_cover,
  video,
  momentssend,
  momentbase,
  momentlike,
  message_list,
  momentmessage_list,
  moment_message_like,
  moment_message,
  moment_del,
} from "@/request/grzx/index.js";
import axios from "axios";
import { formatTimestamp } from "@/utils/common.js";
import { API_ENDPOINTS } from "@/utils/apiConfig";
export default {
  components: {
    SkeletonScreen,
    empty,
    mapLocation,
    emoji,
  },
  data() {
    return {
      uploadProgress: "",
      uploadProgressshow: false,

      uploadProgress: "",
      isOne: 1, // 1发布贴文 2修改贴文
      modalShow: false,
      isLoading: false,
      clockBool: false, // 打卡显示
      activityBool: false, // 活动显示
      activiteName: "",
      behaviorName: "",
      searchValue: "", //位置
      Maporientation: {}, //定位
      articleID: "", //发文id
      activitySearch: "",
      emojiType: false,
      moment_activity: [],

      sadjho: "",
      scdid: "",
      scshow: false,
      scdidyiji: "",
      scshowyiji: false,
      scdiderji: "",
      scshowerji: false,
      sctpsp: true,
      toxiang: "",
      gjisDropdownOpen: false,
      guojiaid: "",
      hdxw: "",
      guojialist: [],
      id: "",
      dataLoaded: false,
      gyiasdid: "",
      qientids: "",
      plyjid: "",
      pldsjuijjm: this.$t("发表评论"),
      liebfbpl: "",
      xthhh: null,
      // 发布图片的
      fbtplist: [],
      fbtpathplist: [],
      // 发布视频
      fbsplist: [],
      hover: false,
      fbspathplist: [],
      mediaList: [],
      nzxsmn: "",
      currentIndex: null,
      currentMediaType: "",
      isFullscreen: false,
      fmimageUrl: "",
      fmimageFile: "",
      beijfmimageUrl: "",
      beijfmimageFile: "",
      info: {
        moment: {
          data: [],
        },
      },
      activity: [],
      task: [],
      currentPage: 1,
      pageSize: 20, // 每页显示的数量
      last_page: "",
      tou: true,
    };
  },
  mounted() {
    this.sadjho = this.$route.params.is_member;
    this.id = this.$route.params.id;
    // this.common_base();
    this.my_center();
    this.momentbase();
    this.xlx();
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    // 在组件销毁前移除事件监听器
    document.removeEventListener("click", this.handleClickOutside);
    EventBus.$off("tdhdthe_wall");
    EventBus.$off("chuanrusffb");
  },
  created() {
    EventBus.$on("tdhdthe_wall", (msg) => {
      console.log(123);
      // 执行方法，处理接收到的数据
      // this.message = msg;
      // 如果需要，可以在这里调用其他方法
      if (this.currentPage < this.last_page) {
        this.currentPage++;
        this.my_center();
      }
    });
    EventBus.$on("chuanrusffb", (msg) => {
      console.log(msg, "msg");
      this.sadjho = msg;
    });
  },
  computed: {
    visibleMoments() {
      const start = this.currentPage * this.pageSize;
      const end = start + this.pageSize;
      return this.info.moment.data.slice(start, end);
    },
  },
  methods: {
    handleClickOnElement(event) {
      // 阻止事件冒泡到文档
      event.stopPropagation();
      // 在这里处理当前元素的点击事件（如果需要）
      console.log("点击了当前元素");
    },
    closeAcitvite() {
      this.activiteName = "";
      this.behaviorName = "";
      this.jhuxa = "";
      this.tdjhuxa = "";
    },
    activiteChange(item, item2) {
      this.activiteName = item?.name;
      this.jhuxa = item?.id;
      this.behaviorName = item2?.title;
      this.tdjhuxa = item2?.id;
      this.activityBool = false;
    },
    handleClickOutside(event) {
      // 检查点击是否发生在当前元素上
      if (this.$refs.activeElement) {
        // 如果不是，则改变状态
        this.hover = false;
      }
    },
    // 点击列表头像旁边的旁边的那哥字进行判断从而进行对应的跳转到哪个活动啥的团队，企业
    fcasa(e) {
      if (e.activity_id > 0) {
        this.$router.push("/hdongdetails?id=" + e.activity_id);
        return;
      } else if (e.organization_id > 0) {
        if (e.organization_identity == 2) {
          this.$router.push("/groups/groupdetails?id=" + e.organization_id);
          return;
        } else {
          this.$router.push("/enterprisedetails?id=" + e.organization_id);
          return;
        }
      }
    },
    // 点击头像进行跳转
    hnsbui(e, v) {
      if (e == localStorage.getItem("user_id")) {
        this.$router.push("/member/" + v);
      } else {
        this.$router.push("/members/" + v);
      }
    },
    tpsdin(e) {
      this.scshowyiji = false;
      this.scshowerji = false;
      if (this.scdid == e) {
        this.scshow = !this.scshow;
      } else {
        this.scshow = true;
      }
      this.scdid = e;
    },
    tpsdinyiji(e) {
      this.scshow = false;
      this.scshowerji = false;
      if (this.scdidyiji == e) {
        this.scshowyiji = !this.scshowyiji;
      } else {
        this.scshowyiji = true;
      }
      this.scdidyiji = e;
    },
    tpsdinerji(e) {
      this.scshow = false;
      this.scshowyiji = false;
      if (this.scdiderji == e) {
        this.scshowerji = !this.scshowerji;
      } else {
        this.scshowerji = true;
      }
      this.scdiderji = e;
    },
    async xlx() {
      const { data } = await momentbase({
        activity_id: this.id,
      });
      this.guojialist = data.activity_action;
    },
    async gjxuanz(e, v) {
      this.hdxw = e;
      this.guojiaid = v;
      this.gjisDropdownOpen = false;
    },
    gjtoggleDropdown() {
      this.gjisDropdownOpen = !this.gjisDropdownOpen;
      // 如果需要，可以在这里添加Bootstrap Dropdown的额外处理逻辑
    },
    funs() {
      this.$router.push("/activity");
    },
    // 点击最大的帖子删除
    async qbudsc(e, v) {
      const { code } = await moment_del({
        moment_id: e,
      });
      if (code == 200) {
        this.$emit("tiewenshul", 0);
        this.$bvToast.toast(this.$t("删除成功"), {
          title: this.$t("login.notice"),
          autoHideDelay: 2000,
          delay: 5000,
          appendToast: true,
          variant: "success",
        });
        this.info.moment.data.splice(v, 1);
        EventBus.$emit("hdonmgh-call-sibling", "Hello from Sib");
      }
    },
    async scpljibdz(e, v, f) {
      const { code } = await moment_message({
        moment_id: e,
        message_id: v,
      });
      if (code == 200) {
        this.$bvToast.toast(this.$t("删除成功"), {
          title: this.$t("login.notice"),
          autoHideDelay: 2000,
          delay: 5000,
          appendToast: true,
          variant: "success",
        });
      }
      this.expandfun(f, e, "", 1);
    },
    // 评论赞
    async pljibdz(e, v, f) {
      const {} = await moment_message_like({
        moment_id: e,
        message_id: v,
      });
      this.expandfun(f, e, "", 1);
    },
    // 赞
    async dianzhan(e, v, m) {
      console.log(m);
      if (v) {
        const { code } = await momentlike({
          moment_id: e,
          type_id: v,
        });
        if (code == 200) {
          for (let i = 0; i < this.info.moment.data.length; i++) {
            if (this.info.moment.data[i].id == e) {
              this.info.moment.data[i].like_type = {
                image: m.image,
                name: m.name,
              };
              this.info.moment.data[i].like.push({
                user_id: localStorage.getItem("user_id"),
                user_nickname: localStorage.getItem("nickname"),
                like_type: {
                  image: m.image,
                },
              });
            }
          }
        }
      } else {
        const { code } = await momentlike({
          moment_id: e,
          type_id: v,
        });
        if (code == 200) {
          for (let i = 0; i < this.info.moment.data.length; i++) {
            if (this.info.moment.data[i].id == e) {
              this.info.moment.data[i].like_type = null;
              for (let j = 0; j < this.info.moment.data[i].like.length; j++) {
                if (
                  this.info.moment.data[i].like[j].user_id ==
                  localStorage.getItem("user_id")
                ) {
                  this.info.moment.data[i].like.splice(j, 1);
                }
              }
            }
          }
        }
      }

      this.hover = false;
    },
    async momentbase() {
      const { data } = await momentbase();
      console.log(data, "indexs");
      this.xthhh = data.like_type;
    },
    // 涂鸦墙发布
    // async favtiewen() {
    //   if (this.sadjho == 1) {
    //   } else {
    //     this.$bvToast.toast(this.$t("您还未加入该活动！"), {
    //       title: this.$t("login.warning"),
    //       autoHideDelay: 2000,
    //       delay: 5000,
    //       appendToast: true,
    //       variant: "danger",
    //     });
    //     return;
    //   }
    //   const { data, msg, code } = await momentssend({
    //     organization_id: "",
    //     activity_id: this.id,
    //     action_id: this.guojiaid,
    //     content: this.nzxsmn,
    //     image: this.fbtpathplist,
    //     video: this.fbspathplist.join(","),
    //   });
    //   if (code == 200) {
    //     this.$emit("tiewenshul", 1);
    //     this.nzxsmn = "";
    //     this.fbtpathplist = [];
    //     this.fbspathplist = [];
    //     this.fbsplist = [];
    //     this.fbtplist = [];
    //     this.currentPage = 1;
    //     this.info.moment.data = [];
    //     this.my_center();
    //     this.$bvToast.toast(this.$t("发布成功"), {
    //       title: this.$t("login.notice"),
    //       autoHideDelay: 2000,
    //       delay: 5000,
    //       appendToast: true,
    //       variant: "success",
    //     });
    //   } else {
    //     this.$bvToast.toast(msg, {
    //       title: this.$t("login.warning"),
    //       autoHideDelay: 2000,
    //       delay: 5000,
    //       appendToast: true,
    //       variant: "danger",
    //     });
    //   }
    // },
    fbspshuz() {
      this.$refs.fbsp.click();
    },
    async fbspinput(e) {
      this.sctpsp = false;
      if (this.fbsplist.length == 1) {
        this.sctpsp = true;
        return;
      }
      this.uploadProgressshow = true;
      this.uploadProgress = "0%";
      const file = e.target.files[0];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", "members-activity-photo");
      formData.append("activity_id", this.id);
      try {
        const response = await axios.post(
          API_ENDPOINTS.UPLOAD_VIDEO,
          formData,
          {
            onUploadProgress: (progressEvent) => {
              // 计算上传进度百分比
              this.uploadProgress =
                Math.round((progressEvent.loaded * 100) / progressEvent.total) +
                "%";
              console.log(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );
            },
          }
        );
        // 处理响应数据
        const { data, msg, code } = response.data;
        if (code == 200) {
          console.log(123123, data);
          this.fbspathplist.push(data.path);
          this.fbsplist.push({
            src: data.url,
            type: "members-photo",
          });
          this.sctpsp = true;
        } else {
          this.$bvToast.toast(msg, {
            title: this.$t("login.warning"),
            autoHideDelay: 2000,
            delay: 5000,
            appendToast: true,
            variant: "danger",
          });
          this.sctpsp = true;
        }
        this.uploadProgressshow = false;
      } catch (error) {
        console.error("上传失败:", error);
        this.uploadProgressshow = false;
        this.uploadProgress = null; // 重置进度
      }
    },
    async fbtpshuz() {
      // 触发隐藏的input的点击事件
      this.$refs.fbtp.click();
    },
    async fbtpimage(e) {
      this.sctpsp = false;
      if (this.fbtplist.length == 10) {
        this.sctpsp = true;
        return;
      }
      for (let i = 0; i < e.target.files.length; i++) {
        this.uploadProgressshow = true;
        this.uploadProgress = "0%";
        const file = e.target.files[i];
        const formData = new FormData();
        formData.append("file", file);
        formData.append("type", "members-photo");
        try {
          const response = await axios.post(
            API_ENDPOINTS.UPLOAD_IMAGE,
            formData,
            {
              onUploadProgress: (progressEvent) => {
                // 计算上传进度百分比
                this.uploadProgress =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) + "%";
                console.log(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                );
              },
            }
          );
          // 处理响应数据
          const { data, msg, code } = response.data;
          if (code == 200) {
            this.fbtpathplist.push(data.path);
            this.fbtplist.push({
              src: data.url,
            });
            this.sctpsp = true;
          } else {
            this.$bvToast.toast(msg, {
              title: this.$t("login.warning"),
              autoHideDelay: 2000,
              delay: 5000,
              appendToast: true,
              variant: "danger",
            });
            this.sctpsp = true;
          }
          this.uploadProgressshow = false;
        } catch (error) {
          console.error("上传失败:", error);
          this.uploadProgressshow = false;
          this.uploadProgress = null; // 重置进度
        }
        // const { data, msg, code } = await image({
        //   file: event.target.files[i],
        //   type: "members-photo",
        // });
      }
    },
    // 删除图片
    shanctp(e) {
      this.fbtplist.splice(e, 1);
      this.fbtpathplist.splice(e, 1);
    },
    showMedia(index, v) {
      this.mediaList = v;
      this.currentIndex = index;
      this.currentMediaType = this.mediaList[index].type;
      this.isFullscreen = true;
    },
    prevMedia() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.currentMediaType = this.mediaList[this.currentIndex].type;
      }
    },
    nextMedia() {
      if (this.currentIndex < this.mediaList.length - 1) {
        this.currentIndex++;
        this.currentMediaType = this.mediaList[this.currentIndex].type;
      }
    },
    closeFullscreen() {
      this.isFullscreen = false;
    },
    // 时间转换
    timeFilter(stringTime) {
      return formatTimestamp(stringTime * 1000);
    },
    async common_base() {
      const { data } = await common_base({
        is_coin: 0,
        is_user: 0,
        is_activity: 0,
        is_task: 1,
        is_moment_activity: 1,
        // activity_search: this.activitySearch,
      });

      data.moment_activity.map((item) => {
        item.unfold = false;
      });
      this.moment_activity = data.moment_activity;
    },
    // handleScroll(event) {
    //   const target = event.target;
    //   const scrollDistance =
    //     target.scrollHeight - target.scrollTop - target.clientHeight;
    //   if (scrollDistance < 10) {
    //     // 当滚动条距离底部小于10px时，认为是滚动到底部
    //     if (this.currentPage < this.last_page) {
    //       this.currentPage++;
    //       this.my_center();
    //     }
    //   }
    // },
    async my_center() {
      const { data, msg, code } = await moment_list({
        page: this.currentPage,
        activity_id: this.id,
      });
      if (code == 200) {
        this.dataLoaded = true;
      }
      this.last_page = data.last_page;
      let newData = data.data;

      let that = this;
      for (let i = 0; i < newData?.length; i++) {
        let imsg = [];
        if (newData[i].video[0]) {
          imsg.push({
            type: "video",
            src: newData[i].video[0]?.url,
            path: newData[i].video[0]?.path,
          });
        }
        for (let j = 0; j < newData[i]?.image?.length; j++) {
          if (!Object.keys(newData[i].image[j]).includes("src")) {
            imsg.push({
              type: "image",
              src: newData[i].image[j]?.url,
              path: newData[i].image[j]?.path,
            });
          } else {
            imsg.push(newData[i].image[j]);
          }
        }
        newData[i].image = imsg;
      }
      this.info = {
        moment: {
          data: [...this.info.moment.data, ...newData],
        },
      };
      EventBus.$emit("hdonmgh-call-sibling", "Hello from Sib");
    },

    custom() {
      this.show = 0;
    },
    // 点击头像
    fmtriggerFileInput() {
      // 触发隐藏的input的点击事件
      this.$refs.fmfileInput.click();
    },
    async fmonFileChange(e) {
      const { data } = await image({
        file: e.target.files[0],
      });
      const {} = await update_avatar({
        image: data.path,
      });
      this.my_center();
    },
    // 点击头像
    beijfmtriggerFileInput() {
      // 触发隐藏的input的点击事件
      this.$refs.beijfmfileInput.click();
    },

    // ######################################################
    // 涂鸦墙发布
    favtiewen() {
      this.modalShow = true;
    },
    scarchBtn() {
      return common_base({
        is_coin: 0,
        is_user: 0,
        is_activity: 0,
        is_task: 1,
        is_moment_activity: 1,
        activity_search: this.activitySearch,
      })
        .then((res) => {
          res.data.moment_activity.map((item) => {
            item.unfold = false;
          });
          this.moment_activity = res.data.moment_activity;
          return true;
        })
        .catch((err) => {
          // console.log(err);
          return false;
        });
    },
    unfoldChange(item) {
      item.unfold = !item.unfold;
    },
    editmapValue(val) {
      console.log(val);

      this.searchValue = val.localSearchValue;
      this.Maporientation = val.Maporientation;
      this.clockBool = false;
    },
    clockBtn() {
      this.clockBool = true;
      this.activityBool = false;
    },
    async activityBtn() {
      this.activitySearch = "";
      let res = await this.scarchBtn();
      if (res) {
        this.activityBool = true;
        this.clockBool = false;
      }
    },
    fanhui() {
      this.clockBool = false;
      this.activityBool = false;
    },
    changeEmoji(val) {
      // 获取textarea输入框元素节点
      let ele = document.querySelector("#textarea");
      // 获取光标
      let cursor = ele.selectionStart;
      // 设置文本内容
      ele.setRangeText(val);
      // 移动光标并聚焦
      ele.selectionStart = cursor + 2;
      ele.focus();
      // 使文本输入框的内容等于当前的值
      this.input = ele.value;
      this.emojiType = false;
    },
    closeChnage() {
      // 清空数据
      this.emojiType = false;
      this.activitySearch = "";
      this.isOne = 1;
      this.fbtplist = [];
      this.fbsplist = [];
      this.nzxsmn = "";
      this.jhuxa = "";
      this.tdjhuxa = "";
      this.fbtpathplist = [];
      this.fbspathplist = [];
      this.searchValue = "";
      this.behaviorName = "";
      this.activiteName = "";
      this.Maporientation = {};
      this.articleID = "";
      this.clockBool = false;
      this.activityBool = false;
    },
    async qrbulletframe() {
      if (this.sadjho == 1) {
      } else {
        this.$bvToast.toast(this.$t("您还未加入该活动！"), {
          title: this.$t("login.warning"),
          autoHideDelay: 2000,
          delay: 5000,
          appendToast: true,
          variant: "danger",
        });
        return;
      }
      if (this.isOne == 1) {
        const { data, msg, code } = await momentssend({
          organization_id: "",
          activity_id: this.id,
          action_id: this.guojiaid,
          content: this.nzxsmn,
          image: this.fbtpathplist,
          longitude: this.Maporientation?.lng,
          latitude: this.Maporientation?.lat,
          address: this.searchValue,
          video: this.fbspathplist.join(","),
        });
        if (code == 200) {
          this.nzxsmn = "";
          this.fbtpathplist = [];
          this.fbspathplist = [];
          this.fbsplist = [];
          this.fbtplist = [];
          this.last_page = 0;
          this.currentPage = 1;
          this.info.moment.data = [];
          this.modalShow = false;
          this.my_center();
          this.$bvToast.toast(this.$t("发布成功"), {
            title: this.$t("login.notice"),
            autoHideDelay: 2000,
            delay: 5000,
            appendToast: true,
            variant: "success",
          });
        } else {
          this.$bvToast.toast(msg, {
            title: this.$t("login.warning"),
            autoHideDelay: 2000,
            delay: 5000,
            appendToast: true,
            variant: "danger",
          });
        }
      } else {
        let imgData = [];
        if (this.fbtpathplist.length > 0) {
          this.fbtpathplist.map((item) => {
            imgData.push(item.path || item);
          });
        }
        let videoData = [];
        if (this.fbspathplist.length > 0) {
          this.fbspathplist.map((item) => {
            videoData.push(item.path || item);
          });
        }
        const { data, msg, code } = await articleUpdate({
          organization_id: "",
          moment_id: this.articleID,
          activity_id: this.jhuxa,
          action_id: this.tdjhuxa,
          content: this.nzxsmn,
          image: imgData,
          longitude: this.Maporientation?.lng,
          latitude: this.Maporientation?.lat,
          address: this.searchValue,
          video: videoData[0],
        });
        if (code == 200) {
          this.nzxsmn = "";
          this.fbtpathplist = [];
          this.fbspathplist = [];
          this.fbsplist = [];
          this.fbtplist = [];
          this.last_page = 0;
          this.currentPage = 1;
          this.info.moment.data = [];
          this.modalShow = false;
          this.my_center();
          this.$bvToast.toast(this.$t("修改成功"), {
            title: this.$t("login.notice"),
            autoHideDelay: 2000,
            delay: 5000,
            appendToast: true,
            variant: "success",
          });
        } else {
          this.$bvToast.toast(msg, {
            title: this.$t("login.warning"),
            autoHideDelay: 2000,
            delay: 5000,
            appendToast: true,
            variant: "danger",
          });
        }
      }
    },
    // 編輯
    editBtn(item, index) {
      this.scshow = !this.scshow;
      this.isOne = 2;
      item.video.map((item) => {
        this.fbsplist.push({
          src: item.url,
          path: item.path,
          type: "members-photo",
        });
      });
      item.image.map((item) => {
        if (item.type == "image") {
          this.fbtplist.push({
            src: item.src,
            path: item.path,
            type: item.type,
          });
        }
      });
      // this.fbtplist = JSON.parse(JSON.stringify(item.image));
      // this.fbsplist =JSON.parse(JSON.stringify( item.video));
      this.fbtpathplist = JSON.parse(JSON.stringify(this.fbtplist));
      this.fbspathplist = JSON.parse(JSON.stringify(this.fbsplist));
      this.nzxsmn = item.content;
      this.jhuxa = item.activity_id;
      this.tdjhuxa = item.action_id;
      this.activiteName = item.activity_name;
      this.behaviorName = item.action_title;
      this.searchValue = item.address;
      this.Maporientation = {
        lat: Number(item.latitude),
        lng: Number(item.longitude),
      };

      this.articleID = item.id;
      this.modalShow = true;
    },
    // async favtiewen() {
    //   if (this.asdjiio == 1) {
    //   } else {
    //     this.$bvToast.toast(this.$t("您还未加入该团体！"), {
    //       title: this.$t("login.warning"),
    //       autoHideDelay: 2000,
    //       delay: 5000,
    //       appendToast: true,
    //       variant: "danger",
    //     });
    //     return;
    //   }
    //   const { data, msg, code } = await momentssend({
    //     organization_id: this.id,
    //     activity_id: "",
    //     action_id: "",
    //     content: this.nzxsmn,
    //     image: this.fbtpathplist,
    //     video: this.fbspathplist.join(","),
    //   });
    //   if (code == 200) {
    //     this.nzxsmn = "";
    //     this.fbtpathplist = [];
    //     this.fbspathplist = [];
    //     this.fbsplist = [];
    //     this.fbtplist = [];
    //     this.currentPage = 1;

    //     this.info.moment.data = [];
    //     this.my_center();
    //     this.$bvToast.toast(this.$t("发布成功"), {
    //       title: this.$t("login.notice"),
    //       autoHideDelay: 2000,
    //       delay: 5000,
    //       appendToast: true,
    //       variant: "success",
    //     });
    //   } else {
    //     this.$bvToast.toast(msg, {
    //       title: this.$t("login.warning"),
    //       autoHideDelay: 2000,
    //       delay: 5000,
    //       appendToast: true,
    //       variant: "danger",
    //     });
    //   }
    // },
    // ###########################

    async beijfmonFileChange(e) {
      const { data } = await image({
        file: e.target.files[0],
      });
      const {} = await update_cover({
        image: data.path,
      });
      this.my_center();
    },
    expandfun(index, id, v, f) {
      if (v) {
        if (this.liebfbpl == "") {
          this.$bvToast.toast(this.$t("评论不能为空哦"), {
            title: this.$t("login.warning"),
            autoHideDelay: 2000,
            delay: 5000,
            appendToast: true,
            variant: "danger",
          });
          return;
        }
        momentmessage_list({
          moment_id: id,
          content: this.liebfbpl,
          message_id: this.plyjid,
          at_user_id: this.qientids,
        }).then((res) => {
          if (res.code == 200) {
            this.liebfbpl = "";
            message_list({
              moment_id: id,
            }).then((res) => {
              this.$set(this.info.moment.data, index, {
                ...this.info.moment.data[index],
                pllist: res.data.data,
              });
              this.$set(this.info.moment.data, index, {
                ...this.info.moment.data[index],
                isExpanded: true,
              });
            });
          }
        });
      } else {
        message_list({
          moment_id: id,
        }).then((res) => {
          this.$set(this.info.moment.data, index, {
            ...this.info.moment.data[index],
            pllist: res.data.data,
          });
          this.$set(this.info.moment.data, index, {
            ...this.info.moment.data[index],
            isExpanded: f == 0 ? false : true,
          });
        });
      }
    },
    showPreview(index) {
      this.currentIndex = index; // 设置当前预览的图片索引
      VuePhotoPreview.show(); // 显示图片预览
    },
    closePreview() {
      VuePhotoPreview.hide(); // 关闭图片预览
    },
  },
};
</script>
<style scoped lang="scss">
@media screen and (max-width: 992px) {
  .sjihhiuui {
    margin-top: 2vh !important;
  }

  .sjbkd1 {
    width: 62% !important;
  }

  .sjbkd2 {
    width: 38% !important;
  }

  .sjduanbjtp {
    height: calc(160px + 0.4vw) !important;
  }

  .mar {
    margin-right: 10px !important;
  }
}

@media screen and (max-width: 692px) {
  .sjbdkd {
    width: calc(80px + 0.4vw) !important;
    height: calc(80px + 0.4vw) !important;
    margin-top: -45px !important;
  }
}

@media screen and (max-width: 1200px) {
  .xiaojiant {
    width: calc(11px + 0.4vw) !important;
    height: calc(11px + 0.4vw) !important;
  }

  .zlxtop {
    width: calc(18px + 0.4vw) !important;
    height: calc(18px + 0.4vw) !important;
  }

  .zlxtops {
    width: calc(24px + 0.4vw) !important;
    height: calc(24px + 0.4vw) !important;
  }

  .zjpadding {
    padding: 10px 15px 10px 15px !important;
  }

  .pgnjksa {
    height: calc(270px + 0.4vw) !important;
  }

  .sjtxtp {
    margin-right: 10px !important;
    width: calc(40px + 0.4vw) !important;
    height: calc(40px + 0.4vw) !important;
  }

  .sjfjtp {
    width: calc(14px + 0.4vw) !important;
  }

  .srkjul {
    margin-right: 10px !important;
  }

  .sjbzt {
    font-size: calc(14px + 0.4vw) !important;
  }

  .sjbxzt {
    font-size: calc(11px + 0.4vw) !important;
  }

  .sjbkd {
    width: 49% !important;
  }

  .sjmb {
    margin-bottom: 1vh !important;
  }

  .yinc {
    display: none !important;
  }

  .sjibanb {
    display: none !important;
  }

  .aaaaa {
    display: block !important;
  }

  .sjihhiuui {
    height: 89.3vh !important;
    // margin-top: 2vh !important;
  }

  .sjtpr {
    height: calc(130px + 0.4vw) !important;
  }

  .sjitp {
    height: calc(203px + 0.4vw) !important;
  }

  .sfdvx {
    height: calc(203px + 0.4vw) !important;
  }

  .sjwidtshhs {
    width: calc(16px + 0.4vw) !important;
    height: calc(16px + 0.4vw) !important;
  }
}

.aaaaa {
  display: none;
}

.widtshh {
  width: calc(10px + 0.4vw);
}

.widtshhs {
  width: calc(10px + 0.4vw);
  height: calc(10px + 0.4vw);
}

.gallery {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  /* 根据需要调整间距 */
}

.gallery-item {
  flex: 1 1 200px;
  /* 宽度、增长因子、基础宽度 */
  // margin: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  text-align: center;
  /* 确保图片居中 */
}

.gallery-item img {
  width: 100%;
  /* 让图片宽度充满容器 */
  height: auto;
  /* 保持图片比例 */
}

/* 覆盖输入框被选中时的样式 */
.form-control:focus {
  /* 清除默认的边框颜色或阴影 */
  border-color: #ced4da !important;
  /* 假设你想要它恢复到非选中状态的颜色 */
  box-shadow: none !important;
  /* 清除默认的聚焦阴影 */
  /* 你可以添加更多的样式规则来进一步自定义你的输入框 */
}

.srk {
  border: 1px dashed #ffd672;
  border-radius: 12px;
  font-size: calc(6px + 0.5vw);
}

.fbtw {
  background: #ffd672;
  border-radius: 12px 12px 12px 12px;

  .fbtw-zi {
    font-weight: 500;
    font-size: calc(5px + 0.4vw);
  }
}

.zhankai {
  background: #f6f4f0;
  text-align: center;
  border-radius: 12px 12px 12px 12px;
}

/* 隐藏水平滚动条 */
.lieb::-webkit-scrollbar {
  display: none;
}

.dingwd {
  width: calc(20px + 0.5vw);
  height: calc(20px + 0.5vw);
}

.ltdgdt {
  max-height: calc(300px + 0.5vw);
  overflow-y: auto;
}

/* 滚动条整体部分 */
.ltdgdt::-webkit-scrollbar {
  width: 8px;
  /* 滚动条的宽度 */
  height: 8px;
  /* 垂直滚动条的宽度 */
}

.custom-progress-bar {
  background-color: #ffd672;
}

/* 滚动条滑块 */
.ltdgdt::-webkit-scrollbar-thumb {
  background-color: #888;
  /* 滑块颜色 */
  border-radius: 20px;
  /* 滑块边角圆滑度 */
  border: 3px solid transparent;
  /* 滑块边框，设置为透明 */
  background-clip: content-box;
  /* 使得边框内不填充背景色 */
}

/* 滚动条轨道 */
.ltdgdt::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道颜色 */
  border-radius: 10px;
  /* 轨道边角圆滑度 */
}

// .xunafuxgio{}
.xunafuxgio:hover {
  transform: scale(1.001);
  /* 悬浮时放大1.1倍 */
  border-radius: 12px;
  // padding: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  /* 悬浮时添加阴影效果 */
}

.ckqbb:hover {
  font-weight: 700;
  transform: scale(1.001);
}

.tpxfbd:hover {
  // transform: scale(1.015);
  /* 悬浮时放大1.1倍 */
  // padding: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  /* 悬浮时添加阴影效果 */
}

.jiantofangda:hover {
  transform: scale(1.2);
}

.fullscreen-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.fullscreen-image {
  max-width: 90%;
  max-height: 90%;
}

.thumbnail {
  margin: 10px;
  cursor: pointer;
}

.image-container {
  position: relative;
  display: inline-block;
  /* 或者其他适合你的布局方式 */
  display: flex;
  align-items: center;
}

.image-container img {
  display: block;
  /* 防止图片下方有空隙 */
  width: 100%;
  /* 或者其他尺寸 */
  height: auto;
}

.image-container .overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  /* 黑色半透明遮罩 */
  /* 你可以在这里添加其他样式，比如阴影效果，但通常遮罩层不需要阴影 */
}

.image-container .overlays {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* 你可以在这里添加其他样式，比如阴影效果，但通常遮罩层不需要阴影 */
}

/* 隐藏水平滚动条 */
.xlcd::-webkit-scrollbar {
  display: none;
}

.xuazz:hover {
  background: #ffebd2;
}

.zhankai {
  background: #ffebd2;
  text-align: center;
  border-radius: 12px 12px 0 0;
  border: none;
  font-weight: 400;
  font-size: calc(6px + 0.4vw);
  color: #1a1a1a;
}

.shanc {
  width: calc(30px + 0.4vw);
  font-size: calc(6px + 0.4vw);
}

.yinchez {
  top: 90%;
  right: 0;
  background: #fffaf0;
  z-index: 9999999999999999999999;
}

.yinchezimg {
  width: calc(20px + 0.4vw);
  height: calc(20px + 0.4vw);
}

.ddd {
  width: calc(25px + 0.4vw);
  height: calc(25px + 0.4vw);
}

.ckqbb:hover {
  transform: scale(1.001);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.ckqb:hover {
  transform: scale(1.101);
}

.dropdown-item {
  text-align: left;
}

.heardCss {
  display: flex;
  align-items: center;
  opacity: 1;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  line-height: 16px;
  text-align: right;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #1a1a1a;
}

.btnCss {
  margin-top: 31px;
  width: 156px;
  height: 48px;
  border-radius: 12px;
  opacity: 1;
  /* 主色 */
  background: #ffd672;
}

.imageCss {
  width: 160px;
  height: 90px;
}

@media screen and (max-width: 692px) {
  .featureCss {
    cursor: pointer;
  }
  .contentCss {
    margin-top: 18px;
    width: 100%;
    height: 150px;
    border-radius: 12px;
    opacity: 1;
    /* 主色衍生（5%） */
    background: #fffdf8;
    box-sizing: border-box;
    /* 主色 */
    border: 1px dashed #ffd672;
  }
  .textfeatureCss {
    opacity: 1;
    font-family: Source Han Sans;
    font-size: 12px;
    font-weight: normal;
    // line-height: 14px;
    letter-spacing: 0em;
    font-variation-settings: "opsz" auto;
    font-feature-settings: "kern" on;
    /* 黑色 */
    color: #1a1a1a;
  }
}

@media screen and (min-width: 692px) {
  .featureCss {
    display: flex;
    align-items: center;
    margin-right: 24px;
    cursor: pointer;
  }
  .contentCss {
    margin-top: 18px;
    width: 100%;
    height: 350px;
    border-radius: 12px;
    opacity: 1;
    /* 主色衍生（5%） */
    background: #fffdf8;
    box-sizing: border-box;
    /* 主色 */
    border: 1px dashed #ffd672;
  }
  .textfeatureCss {
    margin-left: 8px;
    opacity: 1;
    font-family: Source Han Sans;
    font-size: 14px;
    font-weight: normal;
    // line-height: 14px;
    letter-spacing: 0em;
    font-variation-settings: "opsz" auto;
    font-feature-settings: "kern" on;
    /* 黑色 */
    color: #1a1a1a;
  }
}

:deep(.input-group-text) {
  background-color: #fff;
  border-radius: 0 10px 10px 0;
  cursor: pointer;
}

.myactiviteCss {
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  /* 黑色 */
  color: #1a1a1a;
}

.myactiviteTipCss {
  font-family: Source Han Sans;
  font-size: 12px;
  font-weight: normal;
  line-height: 12px;
  text-align: right;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #b66d00;
}

.acitviteDataCss {
  font-family: Source Han Sans;
  margin-top: 14px;
  font-size: 12px;
  font-weight: normal;
  line-height: 12px;
  display: flex;
  align-items: center;
  letter-spacing: 0px;
  font-variation-settings: "opsz" auto;
  /* 黑色 */
  color: #1a1a1a;
}

.acitviteDataCss2 {
  width: 288px;
  margin-top: 10px;
  font-family: Source Han Sans;
  text-align: left;
  font-size: 12px;
  font-weight: normal;
  line-height: 20px;
  display: flex;
  align-items: center;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  /* 二级辅助文字 */
  color: #666666;
}
.triangleB {
  right: 0;
  top: 0;
  width: 0;
  height: 0;
  margin-left: 5px;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #000;
}

.triangleT {
  right: 0;
  top: 0;
  width: 0;
  height: 0;
  margin-left: 5px;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #000;
}
.acitviteNameCss {
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: bold;
  line-height: 14px;
  display: flex;
  align-items: center;
  letter-spacing: 0px;
  font-variation-settings: "opsz" auto;
  /* 黑色 */
  color: #1a1a1a;
}
.activiteItemcss2 {
  width: 95%;
  min-height: 112px;
  border-radius: 12px;
  opacity: 1;
  /* 灰背景色 */
  background: #f6f4f0;
  display: flex;
  padding: 27px 16px;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 990px) {
    flex-direction: column;
  }
}
.activiteItemcss {
  width: 95%;
  height: 72px;
  display: flex;
  padding: 27px 16px;
  align-items: center;
  justify-content: space-between;
  background-color: #ffd672;
  border-radius: 12px;
  opacity: 1;
  /* 橙黄色辅助色衍生（50%） */
  background: #ffebd2;
}
</style>
